import firebaseWeb from "./firebase.web.json";

const VAPID_FIELD = "webPushPublicVapidKey";

/**
 * Deploy target for Firebase Web / FCM client SDK.
 * Set via package.json scripts: REACT_APP_ENV=development | staging | production
 * `npm start` defaults to development when unset (see resolveFirebaseEnv).
 */
export function resolveFirebaseEnv() {
  const explicit = process.env.REACT_APP_ENV;
  if (explicit === "production" || explicit === "staging" || explicit === "development") {
    return explicit;
  }
  return process.env.NODE_ENV === "production" ? "production" : "development";
}

function getRawEnvBlock() {
  const key = resolveFirebaseEnv();
  return firebaseWeb[key] || firebaseWeb.development;
}

/**
 * Options for Firebase `initializeApp` only (no VAPID).
 * @returns {import('firebase/app').FirebaseOptions}
 */
export function getFirebaseConfig() {
  const raw = { ...getRawEnvBlock() };
  delete raw[VAPID_FIELD];
  return raw;
}

/**
 * Web Push VAPID *public* key for this Firebase project (must match project in getFirebaseConfig).
 * Override with REACT_APP_FCM_VAPID_KEY when set (see init-fcm).
 */
export function getWebPushPublicVapidKeyFromConfig() {
  const v = getRawEnvBlock()[VAPID_FIELD];
  return typeof v === "string" && v.trim() ? v.trim() : "";
}
